'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getFetchSubState = exports.getFetchSubState = function getFetchSubState(status, error) {
  switch (status) {
    case 'initial':
      return { ing: false, ed: false };
    case 'request':
      return { ing: true };
    case 'success':
      return { ing: false, ed: true, error: null };
    case 'fail':
      return { ing: false, ed: false, error: error };
    default:
      return {};
  }
};

var fetchReducer = exports.fetchReducer = function fetchReducer(name) {
  var _ref3;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      resultName = _ref.resultName,
      handleSetResult = _ref.handleSetResult,
      getHeaders = _ref.getHeaders;

  var itemName = resultName === true ? 'result' : resultName || undefined;
  return _ref3 = {}, _defineProperty(_ref3, 'MINDSELF_' + name, function undefined(state /*, action*/) {
    return _extends({}, state, _defineProperty({}, name, _extends({}, state[name], getFetchSubState('request'))));
  }), _defineProperty(_ref3, 'MINDSELF_' + name + '_SUCCESS', function (_undefined) {
    function undefined(_x2, _x3) {
      return _undefined.apply(this, arguments);
    }

    undefined.toString = function () {
      return _undefined.toString();
    };

    return undefined;
  }(function (state, action) {
    var _ref2;

    return _extends({}, state, _defineProperty({}, name, _extends({}, itemName && (_ref2 = {}, _defineProperty(_ref2, itemName, handleSetResult ? handleSetResult(action) : action.result), _defineProperty(_ref2, 'resHeaders', getHeaders ? action.headers : undefined), _ref2), getFetchSubState('success'))));
  })), _defineProperty(_ref3, 'MINDSELF_' + name + '_FAIL', function undefined(state, action) {
    var error = action.error;

    var newState = _extends({}, state, _defineProperty({}, name, _extends({}, state[name], getFetchSubState('fail', error))));
    if (error && error.message === 'accessToken is Expired') {
      newState.needToGetNewAccessToken = true;
    }
    return newState;
  }), _defineProperty(_ref3, 'MINDSELF_SET_CLIENT_DEFAULT_REQ_HEADERS', function MINDSELF_SET_CLIENT_DEFAULT_REQ_HEADERS(state, action) {
    if (action.headers.Authorization || action.headers.authorization) {
      return _extends({}, state, { needToGetNewAccessToken: false });
    }
    return state;
  }), _ref3;
};


//////////////////
// WEBPACK FOOTER
// ./~/mindself-api-client/lib/utils/reducers.js
// module id = 45
// module chunks = 1